import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ClassUIModel } from '../../class/class.model';

@Component({
  selector: 'dojo-class-select-option',
  template: `
    <span class="flex w-full items-baseline gap-1">
      <span class="text-md text-primary font-semibold">
        @if (option().emoji) {
          <span class="mr-1">{{ option().emoji }}</span>
        }
        {{ option().name }}
      </span>
      @if (option().course_name || option().course_level) {
        <span class="text-disabled text-xs">
          {{ option().course_name }}{{ option().course_level ? ' ' + option().course_level : '' }}
        </span>
      }
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClassSelectOptionComponent {
  readonly option = input.required<ClassUIModel>();
}
